import { FC } from 'react';
import { ServiceCard } from './ServiceCard';
import type { Service } from '../../types/service.types';

interface ServiceListProps {
  services: Service[];
}

export const ServiceList: FC<ServiceListProps> = ({ services }) => {
  return (
    <div className="space-y-4">
      {services.map((service) => (
        <ServiceCard key={service.id} service={service} layout="horizontal" />
      ))}
    </div>
  );
};
